import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule, Optional, SkipSelf } from '@angular/core';
import { AuthModule } from './auth/auth.module';
import { DialogModule } from './dialog';
import { IconsModule } from './icons/icons.module';
import { ApiUrlInterceptor } from './interceptors';
import { ErrorInterceptor } from './interceptors/error.interceptor';
import { TranslocoCoreModule } from './transloco/transloco.module';

@NgModule({
  imports: [AuthModule, IconsModule, TranslocoCoreModule, DialogModule],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ApiUrlInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptor,
      multi: true,
    },
  ],
})
export class CoreModule {
  /**
   * Constructor
   */
  constructor(@Optional() @SkipSelf() parentModule?: CoreModule) {
    // Do not allow multiple injections
    if (parentModule) {
      throw new Error(
        'CoreModule has already been loaded. Import this module in the AppModule only.'
      );
    }
  }
}
